import { CommonResponseType } from 'data';

export enum PaymentMethodType {
  CASH_CARD = 'cash_card',
  CREDIT = 'credit',
  DEBIT = 'debit',
  WALLET = 'wallet',
  ATTACHED_PAYMENT = 'attached_payment',
  CASH = 'cash',
  FREE = 'zero_dollar',
  EXTERNAL_PAYMENT = 'external',
}

export const paymentMethodLabels: Record<string, string> = {
  cash_card: 'Cash Card',
  credit: 'Credit',
  debit: 'Debit',
  wallet: 'Wallet',
  attached_payment: 'Attached Payment',
  cash: 'Cash',
  zero_dollar: 'Free Item',
  external_payment: 'External Payment',
  external: 'External Payment',
};

export type ProductKind = 'ticket' | 'add-on' | 'token' | 'bundle' | 'undefined-price';

export type RefundEntry = {
  createdOn: string;
  createdBy: string;
  completedOn: string;
  itemUuids: string[];
  refundStatus: string;
  refundFee: number;
  refundSubTotalAmount: number;
  refundTotalAmount: number;
  request: {
    refundType: string;
    itemUuids: string[];
  };
};

export type Refunds = {
  topup_dumpWallet?: RefundEntry;
  full?: RefundEntry;
};

export type OrderMisc = {
  paymentMethodIntent?: string;
  skippedReason?: string;
  rfidUid?: string;
  email?: string;
  receiptRequested?: boolean;
  sessionInfo?: {
    locationName?: string;
  };
};

export type Order = {
  refunds?: Refunds;
  eventId: string;
  createdOn: string;
  totalPrice: number;
  uuid: string;
  products: OrderProduct[];
  topupTypeUuid?: string;
  folioId?: string;
  misc: OrderMisc;
  tip?: number;
  vendorName?: string;
  currency?: string;
  refunded?: boolean;
  refundDate?: string;
};

export type OrderProduct = {
  items: OrdersProductsItemType[];
  productCategory: string;
  productKind: ProductKind;
  quantity: number;
  uuid: string;
  label: string;
  tax?: number;
  unitPrice?: number;
  subtotal?: number;
};

export type OrdersProductsItemType = {
  createdOn: string;
  uuid: string;
  deletedOn: null;
  modifiedOn: string;
  createdBy: string;
  accountId: string;
  eventId: string;
  folioId: string;
  orderId: string;
  productId: string;
  unitPrice: number;
  itemStatus?: string;
  fees?: any[];
};

export type OrdersResponseType = {
  entries: Order[];
} & CommonResponseType;

export type TransactionHistoryType = {
  id: string;
  totalPrice: number;
  subTotalPrice: number;
  tip: number;
  costPrice: number;
  totalFees: number;
  products: OrderProduct[];
};

export type TransactionsHistoryByIdType = {
  [key: string]: TransactionHistoryType;
};

export type Vendor = {
  uuid: string;
  parentFolioUuid: string;
  name: string;
  folioType: string;
  isSlaveFolio: boolean;
  ownedBy: string;
  locationName: string;
  vendorName: string;
};

export type TopupTypeEntry = {
  customName?: string;
  type?: string;
  uuid: string;
  isRefundable: boolean;
  isConsumed: boolean;
};

export type TopupType = {
  entry: TopupTypeEntry;
};
